import { Box, Button, Typography } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import BackOfficeCompaniesTable from "./BackOfficeCompaniesTable";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { usePutCompaniesDisabledMutation } from "../../store/api/backoffice/backofficeApi";

function BackOffice() {
  const backofficeCompanies = useSelector((state: RootState) => state.backofficeCompanies)
  const backofficeSelectedCompanies = useSelector((state: RootState) => state.backofficeSelectedCompanies)
  const [backofficeCompaniesDisable] = usePutCompaniesDisabledMutation()

  const handleDesactiveCompanies = () => {
    backofficeCompaniesDisable({ ...backofficeSelectedCompanies })
  }

  return (
    <Box display='flex' flexDirection='row' justifyContent='center'>
      <Grid container xs={12} direction='column' spacing={2}>
        <Box sx={{padding: '0.1rem 1rem', position: 'sticky', top: '0'}}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', marginBlockStart: '0.3rem' }}>
            <Typography sx={{marginBlock: '0.5rem'}} variant="h6">{backofficeCompanies?.data?.itemList.length} Empresas</Typography>
            <Typography sx={{margin: '0.5rem', marginBlock: '1rem'}} variant="body2">{backofficeSelectedCompanies?.companiesIds.length} Empresas selecionadas</Typography>
            <Button onClick={handleDesactiveCompanies}>Desativar Empresas</Button>
          </Box>
        </Box>
        <BackOfficeCompaniesTable />
      </Grid>
    </Box>
  );
}

export default BackOffice;